import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-compositions',
  templateUrl: './product-compositions.component.html',
  styleUrls: ['./product-compositions.component.css']
})
export class ProductCompositionsComponent implements OnInit {
    public itemsListProductCompositions: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadProductCompositions(): Promise<void> {
        this.itemsListProductCompositions = await this.datatask.Post(2706);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'productcomposition':
                this.stateService?.go('productcomposition', { productcomposition_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadProductCompositions();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productCompositions', {
//        templateUrl: 'views/components/views/productCompositions/productCompositions.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'productCompositionsService', function (stateService, productCompositionsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListProductCompositions: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadProductCompositions() {
//                vm.model.itemsListProductCompositions = await productCompositionsService.listProductCompositions();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'productcomposition':
//                        go({ productcomposition_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadProductCompositions();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
